import { type FC } from 'react'

import { Button } from 'base-ui'

import { getStoryblokHrefLink } from '../../getStoryblokHrefLink'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokButtonType } from '../../model/storyblokTypes.generated'

export const StoryblokButton: FC<
  StoryblokComponentProps<StoryblokButtonType>
> = ({ blok }) => {
  return (
    <Button<'a'>
      href={getStoryblokHrefLink(blok.href)}
      slots={{ root: 'a' }}
      variant={blok.type}
    >
      {blok.text}
    </Button>
  )
}
